import { createContext } from 'react';
import { useFiltersContext } from '../../../../Common/Filters/hooks/useFiltersContext';
import { QUERY_KEYS_SAMU, useChartsData } from '../../../../Common/hooks/useChartsData';


export const ServicesChartsDataContext = createContext();

const ServicesChartsDataProvider = ({ children , module }) => {
    const { filters } = useFiltersContext();
    const { data, isLoading, isError } = useChartsData(
        {
            key: QUERY_KEYS_SAMU.APH_RESULTS,
            url: 'governanceroom/dashboardsamu/results/aph'
        },
        {
            location: filters.unidade.value,
            year: filters.ano?.value,
            month: filters.competencia?.value
        }
    );

    const chartData = data
        ? {
              ocurrenceListByAPHType:
                  data?.ocurrenceListByAPHType ?? [],
              ocurrenceByAPHType:
                  data?.ocurrenceByAPHType ?? []
          }
        : {
              ocurrenceListByAPHType: [],
              ocurrenceByAPHType: []
          };

    const colors = ['#1F77B4', '#FF7F0E'];

    const subtitles = ["teste 1", "teste 2"];

    return (
        <ServicesChartsDataContext.Provider
            value={{
                chartData,
                isLoading,
                isError,
                filters,
                module,
                colors,
                subtitles,
                data
            }}
        >
            {children}
        </ServicesChartsDataContext.Provider>
    );
};

export default ServicesChartsDataProvider;
